export enum CreateReturnCodesOptions {
  CREATE = 'CREATE',
  CREATE_AND_DOWNLOAD_RETURN_CODES = 'CREATE_AND_DOWNLOAD_RETURN_CODES',
  CREATE_AND_DOWNLOAD_POSTERS = 'CREATE_AND_DOWNLOAD_POSTERS',
}

export const CREATE_RETURN_CODES_DEFAULT_OPTION = CreateReturnCodesOptions.CREATE;
